import { useAppSelector } from "@/stores/redux/hooks";
import { countForModeration } from "@/stores/redux/reviewsSelectors";
import { useEffect, useRef } from "react";
import styles from "./MenuLeft.module.css";

export const Counter = ({ style }: { style?: React.CSSProperties }) => {
  const count = useAppSelector(countForModeration);
  const refCounter = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!refCounter.current) return;

    const sticky = document.getElementById("counters");

    if (sticky) {
      refCounter.current.style.top = `${sticky.getBoundingClientRect().top - refCounter.current.offsetHeight / 4}px`;
    }
  }, [refCounter, count]);

  if (count === 0) return null;

  return (
    <div ref={refCounter} className={styles.counter} style={style}>
      {count}
    </div>
  );
};
